module.exports = __webpack_public_path__ + "media/gift/action_icon-991711a9.svg";